export const defaultModalContainerId = "inkline-modal-container";
export const defaultToastContainerId = "inkline-toast-container";
